//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import AppFooter from '~/components/AppFooter.vue'
import BRXComponentMethods from '~/helpers/BRXComponentMethods';

export default Vue.extend({
  name: "Footer",
  components: {
    AppFooter,
},
  props: {
    component: {},
    page: {},
  },
  data () {
    return {
    }
  },
  methods: {
    getDocument() {
      return BRXComponentMethods.getDocument(this.component, this.page);
    },
    getImage(imageRef) {
      return BRXComponentMethods.getImage(imageRef, this.page);
    },
    extractComponent(data) {
      return BRXComponentMethods.extractComponent(data, this.page, this.properties);
    }
  },
  computed: {
    mappedComponent() {
      return this.extractComponent(this.document.getData())
    },
    document() {
      return this.getDocument()
    },
    meta() {
      return this.component.getParameters()
    },
    properties() {
      const systemProperties = ['document-template-query', 'folder-template-query', 'parameter', 'root'];
      const filteredProperties = Object.fromEntries(
        Object.entries(this.meta).filter(entry =>
          !systemProperties.includes(entry[0]) && entry[1] !== undefined
        )
      );
      return filteredProperties;
    }
  },
})
